// jiboomba URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/jiboomba";
// const BASE_URL = "https://iccpanel.com/api/v1/betwin";
const BASE_URL = "https://uat.iccpanel.com/api/v1/betwin";
//
// const BASE_URL = "https://staging.syscorp.in/api/v1/test";

// Namibia URL
// const BASE_URL = "https://staging.syscorp.in/api/v1/test2";
// const BASE_URL = "https://staging.syscorp.in/api/v1/betwin";

export default BASE_URL;
